/* global google */
//
// ─── IMPORTING NECESSARY ELEMENTS ───────────────────────────────────────
//
import React, { useEffect, useState, useRef } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Formfields from './Formfields';

//
// ─── COMPONENT DECLARATION ───────────────────────────────────────
//
const GeoSearch = (props) => {
    const [geo, setGeo] = useState([]);
    const [search, setSearch] = useState('');
    const [geoApi, setGeoApi] = useState({});
    const [defaultValue, setDefaultValue] = useState(props.default || {});
    const tokenRef = useRef(null);

    useEffect(() => {
        if (!search || search.trim().length < 3) return;

        const loadSuggestions = async () => {
            const { AutocompleteSessionToken, AutocompleteSuggestion } = await google.maps.importLibrary("places");
            if (!tokenRef.current) tokenRef.current = new AutocompleteSessionToken();

            const response = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
                input: search,
                language: "fr-FR",
                includedRegionCodes: ["fr", "lu", "gb", "ch", "de", "it", "es", "pt","be"],
                sessionToken: tokenRef.current,
            });

            if (!response?.suggestions?.length) return setGeo([]);

            const geoArray = response.suggestions
                .filter((s) => s.placePrediction)
                .map((s) => ({
                    label: `${s.placePrediction.mainText.text} ${s.placePrediction.secondaryText?.text || ""}`,
                    placeId: s.placePrediction.placeId,
                }));

            setGeo(geoArray);
        };

        const timer = setTimeout(loadSuggestions, 300);
        return () => clearTimeout(timer);
    }, [search]);
    const handleSelect = (value) => {
        const getPlaceDetails = async () => {
            const { Place } = await google.maps.importLibrary("places");
            const token = tokenRef.current;
            const place = new Place({ id: value.placeId });

            await place.fetchFields({
                fields: ["addressComponents", "formattedAddress", "location"],
                sessionToken: token,
            });

            if (place) {
                const components = place.addressComponents || [];

                const geoValues = {
                    label: place.formattedAddress || "",
                    city:
                        getComponentValue(components, "locality") ||
                        getComponentValue(components, "administrative_area_level_2") ||
                        getComponentValue(components, "administrative_area_level_1") ||
                        "",
                    cp: getComponentValue(components, "postal_code"),
                    address: getStreetAddress(components),
                };

                setGeoApi({ ...geoValues });
                if (typeof props.handleChange === "function") {
                    props.handleChange({ [props.name]: geoValues });
                }
                tokenRef.current = null;
            }
        };

        getPlaceDetails();
    };

    const getComponentValue = (addressComponents, type) => {
        if (!Array.isArray(addressComponents)) return "";
        const component = addressComponents.find((c) => c.types.includes(type));

        if (!component) return "";
        return component.longText || component.shortText || component.long_name || component.short_name || "";
    };

    const getStreetAddress = (addressComponents) => {
        const streetNumber = getComponentValue(addressComponents, "street_number");
        const streetName = getComponentValue(addressComponents, "route");
        return streetNumber && streetName ? `${streetNumber} ${streetName}` : streetName || "";
    };

  //
  // ─── COMPONENT RENDER ───────────────────────────────────────
  //
  return (
    geo && (
      <>
        <Autocomplete
          id={props.name}
          size="small"
          options={geo}
          clearOnBlur={false}
          filterOptions={(x) => x}
          // getOptionLabel={(option) => option.label}
          onInputChange={(event, newInputValue, reason) => {
            if (reason === 'reset') return;
            setSearch(newInputValue);
          }}
          onChange={(e, value) => {
            if (value) {
              handleSelect(value);
            }
          }}
          disabled={props.disabled}
          value={search || defaultValue.geo}
          className={props.className}
          renderInput={(params) => (
            <TextField
              {...params}
              label={props.label}
              placeholder={props.placeholder}
              name={props.name}
              InputLabelProps={{ shrink: Boolean(props.shrink) }}
            />
          )}
        />

        <Formfields
          field={{
            type: 'hidden',
            component: 'text',
            name: `${props.name ? `${props.name}_` : ''}address`,
            hidden: true,
            value:
              geoApi.address || (geoApi.cp && !geoApi.address)
                ? geoApi.address
                : defaultValue.address,
          }}
        />
        <Formfields
          field={{
            type: 'hidden',
            component: 'text',
            name: `${props.name ? `${props.name}_` : ''}cp`,
            hidden: true,
            value: geoApi.cp || defaultValue.cp,
          }}
        />
        <Formfields
          field={{
            type: 'hidden',
            component: 'text',
            name: `${props.name ? `${props.name}_` : ''}city`,
            hidden: true,
            value: geoApi.city || defaultValue.city,
          }}
        />
        {/*  <input*/}
        {/*      type="hidden"*/}
        {/*      name={`${props.name}_address`}*/}
        {/*      value={geoApi.address || defaultValue.address || ''}*/}
        {/*  />*/}
        {/*  <input*/}
        {/*      type="hidden"*/}
        {/*      name={`${props.name}_cp`}*/}
        {/*      value={geoApi.cp || defaultValue.cp || ''}*/}
        {/*  />*/}
        {/*  <input*/}
        {/*      type="hidden"*/}
        {/*      name={`${props.name}_city`}*/}
        {/*      value={geoApi.city || defaultValue.city || ''}*/}
        {/*  />*/}
      </>
    )
  );
};

export default GeoSearch;
